import { map, reduce, snakeCase } from 'lodash'
import { v4 as uuid } from 'uuid'

export const transformMenuSettings = (
  menuSettings,
  venueUuid,
  revenueCenterUuid
) => {
  const menuSettingsData = reduce(
    menuSettings,
    (all, settings) => {
      const menuSettingsDataValues = reduce(
        settings,
        (res, setting, settingIndex) => {
          const values = map(setting, (value, valueIndex) => {
            if (valueIndex === 'leadingOrderNumberText') {
              return {
                name: snakeCase(valueIndex),
                value: value === true ? 'PO-' : '',
                venue_uuid: venueUuid,
                revenue_center_uuid: revenueCenterUuid,
                menu_uuid: settingIndex,
                external_ref_id: uuid(),
              }
            } else {
              return {
                name: snakeCase(valueIndex),
                value: value,
                venue_uuid: venueUuid,
                revenue_center_uuid: revenueCenterUuid,
                menu_uuid: settingIndex,
                external_ref_id: uuid(),
              }
            }
          })

          return [...res, ...values]
        },
        []
      )

      return [...all, ...menuSettingsDataValues]
    },
    []
  )

  return menuSettingsData
}
